import styled from 'styled-components'

export const Container = styled.footer`
  width: 100%;
  padding: 10px 20px;
  background: ${({ theme }) => theme.colors.header || theme.colors.primary || '#2c30af'};
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  margin-top: auto;
`

export const Text = styled.p`
  margin: 0;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-align: center;
  line-height: 1.5;
  letter-spacing: 0.01em;
`
